import { Box, Button, IconButton, Typography } from '@mui/material'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { DetailKeyValue } from '../../../../components'
import { DinamicForm } from '../../../../components/dinamicForm'
import { FiltersDrawer } from '../../../../components/filtersDrawer'
import SimpleModal from '../../../../components/modal/simpleModal'
import StepperCreate from '../../../../components/stepperCreate'
import { useContextState } from '../../../../hooks/theme'
import { AssignScheduleErrors } from '../../../../service/userSchedule/response'
import { Constants } from '../../../../utils/constants'
import { userScheduleServiceFetch } from '../../../../utils/constants/callService'
import { RequestErrors } from '../../../../utils/enums'
import { icons } from '../../../../utils/icons'
import { toUnitTimeZone } from '../../../../utils/methods/calcDate'
import { handleAllErrors } from '../../../../utils/methods/handleErrors'
import { validateDateTime } from '../../../../utils/methods/validateDateRange'
import { ObjectGeneric } from '../../../../utils/types/generals'
import { CurrentStep } from '../components'
import { useGetDAta } from './hooks/getDAta'
import { useInput } from './hooks/input'
import { useColumns, useSteps } from './hooks/tables'
import { useFilter } from './hooks/useFilter'
import { userCannotSelectcUsers } from './methods/validateByUser'
import { useStyles } from './styles'
import { FormatCreateAndUpdate } from './typing'
import { DaysWeek } from '../../../reportFolio/pages/notifications/pages/main/utils/enums/tabs'
import { FrequencyEnum } from '../../../calendar/pages/form/components/steps/configCalendar/enums'
import { getDataByFrequency } from '../../../calendar/pages/main/methods'
import { eachDayOfInterval } from 'date-fns'

dayjs.extend(utc);
dayjs.extend(timezone);

const UserScheduleDetail = () => {
  const refTable = useRef<{ removeChecks?: (payload: { value: boolean }) => void }>({})
  const { id } = useParams()
  const styles = useStyles()
  const { list, isLoadingEndpoints, listItems, userAndQuestionnaireDetail } =
    useGetDAta({ id })
  const navigate = useNavigate()
  const { stepsList, titles, footers } = useSteps({ id })
  const { t } = useTranslation()
  const { colors } = useContextState()
  const [steps, setSteps] = useState(!!id || userCannotSelectcUsers() ? 1 : 0)
  const [errors, setErrors] = useState<Record<string, string>>({})

  const [data, setData] = useState<ObjectGeneric>({})
  const [isLoadingConfirm, setIsLoadingConfirm] = useState(false)
  const [useScheduled, setUserScheduled] = useState<
    Record<string, ObjectGeneric>
  >({})
  const [selectSchedule, setSelectSchedule] = useState<
    Record<string, (number | string)[]>
  >({})
  const {
    columns,
    currentUser,
    userSelectes,
    refRange,
    items,
    loadings,
    setItems,
    getUserUnits,
    handleCloseScheduleUser,
    handlTableItemsHaveErrors,
  } = useColumns({
    useScheduled,
  })
  const {
    handleFilter,
    handleCheanFilter,
    row,
    filterData,
    counter,
    disabledChecks,
    removeDisabled,
    handledSent,
  } = useFilter({
    steps,
    lists: list,
    selectSchedule,
    useScheduled,
  })

  const [mimTimeZone, setMimTimeZone] = useState<{ code: string; value: number; }>({ code: "", value: 0 })
  const [flag, setFlag] = useState(true)
  const [startDate, setStartDate] = useState<number | undefined>(undefined)
  const [selectedDays, setSelectedDays] = useState<number[]>([])
  const [children, setChildren] = useState<string[]>([])
  const childrenRef = useRef<string[]>([]);

  const { input } = useInput({ listItems, steps })
  const [openModal, setOpenModal] = useState<{
    open: boolean
    title: string
    description: string
    removeCancel?: boolean
    method?: () => void
    children?: JSX.Element
  }>({
    open: false,
    title: t('reportFolio.snackbar.areYouSureonDeleteThisFile'),
    description: '',
  })

  const handleSelect = ({ checks }: { checks: (number | string)[] }) => {
    if (steps > 1) {
      let selectedWithSchedule: (number | string)[] = []

      checks.forEach((item) => {
        if (!!useScheduled[item]) {
          selectedWithSchedule.push(item)
        }
      })
      removeDisabled({ arr: selectedWithSchedule })
      setSelectSchedule((prev) => ({
        ...prev,
        [steps]: selectedWithSchedule,
      }))
    } else {
      let newScheduled: string[] = []
      selectSchedule[2]?.forEach((item: any) => {
        const splitItem = item.split('-')
        if (!checks.some(itemCHeck => itemCHeck == splitItem[steps])) {
          newScheduled.push(item)
        }
      })

      setSelectSchedule((prev) => ({
        ...prev,
        [steps]: checks,
        2: prev?.[2]?.length ? prev[2].filter(item => !newScheduled.includes(item.toString())) : []
      }))
    }
  }

  const goBack = () => {
    setOpenModal((prev) => ({
      ...prev,
      title: t('general.exit'),
      open: true,
      children: undefined,
      method: () => {
        navigate('/dashboard/schedule-user/')
      },
    }))
  }

  const handleCloseModal = () => {
    setOpenModal((prev) => ({
      ...prev,
      open: false,
      children: undefined,
    }))
    setIsLoadingConfirm(false)
  }

  const handleSteps = (step: number) => {
    handleCloseScheduleUser()
    if ([3].includes(step + (steps ?? 0))) {
      areYouSureOfScheduled()
    } else {
      setSteps((prev) => prev + step)
    }
  }

  const areYouSureOfScheduled = () => {
    setOpenModal((prev) => ({
      ...prev,
      title: t(`schedule.modal.submit.${id ? 'titleUpdate' : 'title'}`),
      description: t(`schedule.modal.submit.${id ? 'descriptionUpdate' : 'description'}`),
      removeCancel: undefined,
      open: true,
      children: undefined,
      method: () => {
        confirmSchedule()
      },
    }))
  }

  const confirmSchedule = () => {
    handleCloseScheduleUser()
    const notAllItemsAreMArked = row?.some(
      (item: any) => !selectSchedule[steps]?.includes(item?.id ?? '')
    )
    let title = ''

    /* if (notAllItemsAreMArked) {
      title = t('useScheduled.detail.errors.someScheduleWereNotSelected')
    } */

    if (!title) {
      submitSchedule({ sentAll: true })
    } else {
      setOpenModal((prev) => ({
        ...prev,
        title: title,
        description: !!title
          ? t('useScheduled.detail.errors.doYouWantToCreateTheSchedule')
          : '',
        removeCancel: undefined,
        open: true,
        children: undefined,
        method: () => {
          submitSchedule()
        },
      }))
    }
  }

  const createOrEditSubmit = async ({
    body,
    copySelectedSchedule,
    sentAll,
  }: {
    body: FormatCreateAndUpdate[]
    copySelectedSchedule: (string | number)[]
    sentAll?: boolean
  }) => {
    let response: AssignScheduleErrors
    setIsLoadingConfirm(true)
    if (!id) {
      response = await userScheduleServiceFetch.createrUserSchedule({
        body,
      })
    } else {
      response = await userScheduleServiceFetch.updateUserSchedule({
        body: body[0],
        id,
      })
    }

    setIsLoadingConfirm(false)
    let errors: Record<string, string[]> = {}
    if (!response?.errors) {
      if (['01', '02'].includes(response.code) && response.code != '404') {
        const responseData = response?.data instanceof Array ? response?.data : [response?.data]
        responseData?.forEach((item) => {
          const userAndQuestionnareIds = `${item.userAssignId}-${item.questionnaireMainId}`
          if (!!copySelectedSchedule?.length) {
            copySelectedSchedule = copySelectedSchedule.filter(
              (itemSchedule) => itemSchedule != userAndQuestionnareIds
            )
          }

          errors = {
            ...errors,
            [userAndQuestionnareIds]: item.errors.map(
              (itemErrors) => itemErrors.code
            ),
          }
        })

        handledSent({ sent: copySelectedSchedule as string[] })
        setSelectSchedule((prev) => ({
          ...prev,
          [steps]: prev[steps]?.filter(
            (item) =>
              !copySelectedSchedule.some((itemSelected) => itemSelected == item)
          ),
        }))

        handlTableItemsHaveErrors({ id: errors })
      } else {
        handledSent({ sent: copySelectedSchedule as string[] })
        setSelectSchedule((prev) => ({
          ...prev,
          [steps]: prev[steps]?.filter(
            (item) =>
              !copySelectedSchedule.some((itemSelected) => itemSelected == item)
          ),
        }))
      }

      if (!Object.values(errors)?.length && response.code != '404') {
        setOpenModal((prev) => ({
          ...prev,
          title: t(
            `useScheduled.detail.errors.${!!id ? 'scheduleWereUpdated' : 'scheduleWereCreated'
            }`
          ),
          description: '',
          removeCancel: true,
          open: true,
          children: undefined,
          method: () => {
            if (!!sentAll) {
              navigate('/dashboard/schedule-user/')
            } else {
              handleCloseModal()
            }
          },
        }))
      } else {
        const isUpdate = !!id ? 'wasAnErrorUpdated' : 'wasAnErrorCreated'
        setOpenModal((prev) => ({
          ...prev,
          title: t(`useScheduled.detail.errors.${response?.code == '404' ? isUpdate : 'someScheduledWereNotCreated'}`),
          description: '',
          removeCancel: true,
          open: true,
          children: undefined,
          method: () => {
            handleCloseModal()
          },
        }))
      }
    } else {
      const isUpdate = !!id ? 'wasAnErrorUpdated' : 'wasAnErrorCreated'
      setOpenModal((prev) => ({
        ...prev,
        title: handleAllErrors(response.code as RequestErrors ?? response?.errors?.[0]?.code, t, `useScheduled.detail.errors.${isUpdate}`),
        description: '',
        removeCancel: true,
        open: true,
        children: undefined,
        method: () => {
          handleCloseModal()
        },
      }))

    }
  }

  const submitSchedule = async (payload?: { sentAll?: boolean }) => {
    let copySelectedSchedule = structuredClone(selectSchedule[steps])
    /* let scheduledExpired: {
      title: string
      titleExpired: string
      expired: {
        user: string
        questionnaire: string
      }[]
    } = {
      title: '',
      titleExpired: '',
      expired: [],
    } */

    setIsLoadingConfirm(true)
    let body: {
      dateStart?: string
      dateEnd?: string
      questionnaireMainId: number
      userAssignId: number
      notified?: number
      notifyAdmin: number
      openScheduled: boolean
      storeId?: string | null
      duration?: number | null
      days?: number[] | null
      frequency?: string
      every?: string | null
      timeStart?: string | null
      timeEnd?: string | null
    }[] = []

    selectSchedule[steps]?.forEach((item) => {
      const scheduledCopy = useScheduled[item]
      /* const scheduledOsExpired =
        scheduledCopy?.to && scheduledCopy?.to <= Date.now()


      if (!!scheduledOsExpired && !scheduledCopy?.openQuestionnaire) {
        scheduledExpired.title = t(
          'useScheduled.detail.errors.someDatesAreExpired'
        )
        const schedule: any = row?.find(
          (itemSchedule: any) => itemSchedule?.id == item
        )
        copySelectedSchedule = copySelectedSchedule.filter(
          (itemSelected) => itemSelected != item
        )
        scheduledExpired.expired.push({
          user: schedule?.user,
          questionnaire: schedule?.questionnaireName,
        })
      } */
      const userAndQuestionaire = item.toString().split('-')
      const { dateEnd, dateStart, days, duration, every, frequency, timeEnd, timeStart } = getDataByFrequency(scheduledCopy);
      body.push({
        openScheduled: !!scheduledCopy?.openQuestionnaire,
        questionnaireMainId: parseInt(userAndQuestionaire[1]),
        storeId: /* Boolean(scheduledCopy?.displayStores) && */ Boolean(scheduledCopy.store) ? scheduledCopy.store?.value : null,
        userAssignId: parseInt(userAndQuestionaire[0]),
        notified: !!scheduledCopy?.notified ? 1 : 0,
        notifyAdmin: !!scheduledCopy?.notifiedAdmin ? 1 : 0,

        ...!scheduledCopy?.openQuestionnaire && {
          dateStart: dateStart,
          dateEnd: dateEnd,
          every: every,
          timeStart: timeStart,
          timeEnd: timeEnd,
          frequency: frequency,
          duration: duration,
          days: days
          /* dateStart: scheduledCopy?.from
            ? dayjs(scheduledCopy?.from).format(Constants.dayjsFormat3)
            : '',
          dateEnd: scheduledCopy?.to
            ? dayjs(scheduledCopy?.to).format(Constants.dayjsFormat3)
            : '', */
        },




      })
    })
    if (!!body?.length) {
      /* if (!!scheduledExpired?.expired?.length) {
        setIsLoadingConfirm(false)
        setOpenModal((prev) => ({
          ...prev,
          title: scheduledExpired.title,
          description: t('useScheduled.detail.errors.doYouWantToCreateTheSchedule'),
          open: true,
          // removeCancel: true,
          method: () => {
            createOrEditSubmit({ body, copySelectedSchedule, })
          },
          children: !!scheduledExpired?.expired?.length ? (
            <ul style={styles.ul}>
              {scheduledExpired?.expired?.map((item) => (
                <li>
                  <DetailKeyValue
                    sxContainer={styles.containerUl}
                    valueSize="12px"
                    captionSize="10px"
                    value={item.user}
                    caption={item.questionnaire}
                  />
                </li>
              ))}
            </ul>
          ) : undefined,
        }))
      } else { */
      createOrEditSubmit({
        body,
        copySelectedSchedule,
        sentAll: payload?.sentAll,
      })
      /* } */
    } else {
      setOpenModal((prev) => ({
        ...prev,
        title: t('useScheduled.detail.errors.wrongDates'),
        description: '',
        removeCancel: true,
        open: true,
        children: undefined,
        method: () => {
          handleCloseModal()
        },
      }))
    }
  }

  const lookForInvalidateFields = () => {
    if (data?.frequency == FrequencyEnum.UNIQUE) {
      return !(
        Boolean(data?.from) && Boolean(data?.to) && Boolean(data?.frequency) &&
        dayjs(data?.to).isAfter(dayjs(data.from).add(5, 'minute')) &&
        dayjs(data?.to).isAfter(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value,)).add(5, 'minute'))
      )
    }
    if (data?.frequency == FrequencyEnum.DAYLI) {
      return !(
        selectedDays.length !== 0 &&
        Boolean(data?.startDateDaily) && Boolean(data?.endDateDaily) && Boolean(data?.fromDateDaily) && Boolean(data?.toDateDaily) &&
        dayjs(data?.endDateDaily).isAfter(dayjs(data.startDateDaily).add(4, 'minute')) &&
        dayjs(data?.toDateDaily).isAfter(dayjs(data.fromDateDaily))
      )
    }
    if (data?.frequency == FrequencyEnum.WEEKLY) {
      return !(
        selectedDays.length !== 0 &&
        Boolean(data?.startDate) && Boolean(data?.duration) && Boolean(data?.dayOfWeek) && Boolean(data?.endDate) && Boolean(data?.fromDateWeekly) && Boolean(data?.toDateWeekly) &&
        dayjs(data?.toDateWeekly).isAfter(dayjs(data.fromDateWeekly).add(6, 'days')) &&
        selectedDays.includes(data?.dayOfWeek)
      )
    }

    if (data?.frequency == FrequencyEnum.CYCLIC) {
      return !(
        selectedDays.length !== 0 &&
        Boolean(data?.startDate) && Boolean(data?.duration) && Boolean(data?.endDate) && Boolean(data?.fromDateCycli) && Boolean(data?.toDateCycli) &&
        dayjs(data?.toDateCycli).isAfter(dayjs(data.fromDateCycli))
        //validar que sea una semana despues
      )
      //&&
      //validar que sea una semana despues
    }

    return false
    //Aca van las validaciones del disable

  }


  const disableAssginedSchedule = () => {
    /* const existErrors = Object.values(errors ?? {})?.some((item) => !!item)
    const from = data?.from
    const to = data?.to

    return !!data?.openQuestionnaire ? false : !(from?.valueOf?.() && to?.valueOf?.()) || !!existErrors */
    if (data?.openQuestionnaire) return false
    if (Object.values(errors).some((item: any) => !!item)) return true
    return lookForInvalidateFields()
  }

  const handleDisabled = (payload?: { schedule: boolean }) => {
    const isAnyThingSelected = !!selectSchedule[steps]?.length

    const disabledBySteps: Record<string, () => boolean> = {
      2: () => {
        return !selectSchedule[steps]?.some((item) => useScheduled[item])
      },
    }
    if (!!payload?.schedule) {
      return !!disabledBySteps?.[steps]?.()
    }

    return !isAnyThingSelected || !!disabledBySteps?.[steps]?.() || (!!id && !!isLoadingEndpoints?.questionnaires)
  }

  const onChange = ({
    target,
    keyboard,
  }: {
    target: { name: string; value: any }
    keyboard?: string
  }) => {
    const { name, value } = target
    const body = { ...data, [name]: value }
    const from = name === 'from' ? value : data?.from
    const to = name === 'to' ? value : data?.to

    if (name === 'frequency') {
      setErrors(prev => ({
        ...prev,
        days: ''
      }))
    }

    if (['from', 'to'].includes(name)) {
      const from = name == 'from' ? value : data.from
      const to = name == 'to' ? value : data.to

      if (Boolean(from)) {
        let errorMessage = ''
        /* if (dayjs(from).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)))) { errorMessage = t('general.validations.minimusCurrentDayStart') } */
        if (dayjs(from).startOf('minute').isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).startOf('minute'))) { errorMessage = t('general.validations.minimusCurrentDayStart') }
        setErrors(prev => ({
          ...prev,
          from: errorMessage
        }))
      }

      if (Boolean(to)) {
        let errorMessage = ''
        if (dayjs(to).isBefore(dayjs(from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
        //if (dayjs(to).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
        setErrors(prev => ({
          ...prev,
          to: errorMessage
        }))
      }
    }

    /* if (to) {
      setErrors((prev) => ({
        ...prev,
        to:
          dayjs(to).isBefore(dayjs(from).add(5, 'minute'))
            ? t('useScheduled.detail.errors.minimus5minute')
            : '',
      }))
    }

    if (from) {
      setErrors((prev) => ({
        ...prev,
        to:
          dayjs(to).isBefore(dayjs(from).add(5, 'minute'))
            ? t('useScheduled.detail.errors.minimus5minute')
            : '',
      }))
      setErrors((prev) => ({
        ...prev,
        from:
          dayjs(from).startOf('minute').isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).startOf('minute'))
            ? t('general.validations.minimusCurrentDayStart')
            : '',
      }))
    } */

    if (keyboard) {
      const reponse = validateDateTime(keyboard)
      setErrors((prev) => ({
        ...prev,
        [name]: !reponse
          ? t('useScheduled.detail.errors.invalidaDtae')
          : prev?.[name] ?? '',
      }))
    }

    if (name == 'displayStores' && !value) {
      body.store = null
    }
    if (name == 'dayOfWeek') {
      setStartDate(value == 0 ? DaysWeek.SUNDAY : value)
    }

    if (['startDateDaily', 'endDateDaily'].includes(name)) {
      const startDateDaily = name == 'startDateDaily' ? value : data.startDateDaily
      const endDateDaily = name == 'endDateDaily' ? value : data.endDateDaily

      if (Boolean(endDateDaily)) {
        let errorMessage = ''
        const start = dayjs(startDateDaily);
        const end = dayjs(endDateDaily);
        const diffInMinutes = end.diff(start, 'minute');
        if (diffInMinutes < 5) { errorMessage = t('general.validations.minimus5minute') }
        setErrors(prev => ({
          ...prev,
          endDateDaily: errorMessage
        }))
      }
    }

    if (['fromDateDaily', 'toDateDaily'].includes(name)) {
      const fromDateDaily = name == 'fromDateDaily' ? value : data.fromDateDaily
      const toDateDaily = name == 'toDateDaily' ? value : data.toDateDaily

      if (Boolean(fromDateDaily)) {
        const day = dayjs(fromDateDaily).day();
        setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
      }

      if (Boolean(toDateDaily)) {
        let errorMessage = ''
        const start = dayjs(fromDateDaily);
        const end = dayjs(toDateDaily);
        const diffInDays = end.diff(start, 'day');
        if (diffInDays < 1) { errorMessage = t('general.validations.minimus1Day') }
        setErrors(prev => ({
          ...prev,
          toDateDaily: errorMessage
        }))
      }
    }

    if (['fromDateWeekly', 'toDateWeekly'].includes(name)) {
      const fromDateWeekly = name == 'fromDateWeekly' ? value : data.fromDateWeekly
      const toDateWeekly = name == 'toDateWeekly' ? value : data.toDateWeekly
      /* if (Boolean(fromDateWeekly)) {
        const day = dayjs(fromDateWeekly).day();
        setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
      } */
      if (Boolean(toDateWeekly)) {
        let errorMessage = ''
        const start = dayjs(fromDateWeekly);
        const end = dayjs(toDateWeekly);
        const diffInDays = end.diff(start, 'day');
        if (diffInDays < 7) { errorMessage = t('general.validations.minimus7Day') }
        setErrors(prev => ({
          ...prev,
          toDateWeekly: errorMessage
        }))
      }
    }

    if (['fromDateCycli', 'toDateCycli'].includes(name)) {
      const fromDateCycli = name == 'fromDateCycli' ? value : data.fromDateCycli
      const toDateCycli = name == 'toDateCycli' ? value : data.toDateCycli

      if (Boolean(fromDateCycli)) {
        const day = dayjs(fromDateCycli).day();
        setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
      }

      if (Boolean(toDateCycli)) {
        let errorMessage = ''
        const start = dayjs(fromDateCycli);
        const end = dayjs(toDateCycli);
        const diffInDays = end.diff(start, 'day');
        if (diffInDays < 1) { errorMessage = t('general.validations.minimus1Day') }
        setErrors(prev => ({
          ...prev,
          toDateCycli: errorMessage
        }))
      }
    }

    if (['fromDateDaily', 'toDateDaily', 'days'].includes(name)) {
      const fromDateCycli = name == 'fromDateDaily' ? value : data.fromDateDaily
      const toDateCycli = name == 'toDateDaily' ? value : data.toDateDaily
      const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
      let errorMessage = ''
      let flag: boolean = true;
      if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
        let current = dayjs(fromDateCycli)
        const end = dayjs(toDateCycli)

        while (current.isSame(end) || current.isBefore(end)) {
          const dayOfWeek = current.day()
          if (newSelectedDays.includes(dayOfWeek)) {
            flag = false;
          }
          current = current.add(1, 'day')
        }

        if (flag) { errorMessage = t('general.validations.daysArentValid') }
        setErrors(prev => ({
          ...prev,
          days: errorMessage
        }))
      }
    }

    if (['fromDateCycli', 'toDateCycli', 'days', 'duration'].includes(name)) {
      const fromDateCycli = name == 'fromDateCycli' ? value : data.fromDateCycli
      const toDateCycli = name == 'toDateCycli' ? value : data.toDateCycli
      const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
      const duration = name == 'duration' ? value.replace(/[a-zA-Z]/g, '') : data.duration?.replace(/[a-zA-Z]/g, '');
      let errorMessage = ''
      let secondErrorMessage = ''
      let flag: boolean = true;
      if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
        let current = dayjs(fromDateCycli)
        const end = dayjs(toDateCycli)

        while (current.isSame(end) || current.isBefore(end)) {
          const dayOfWeek = current.day()
          if (newSelectedDays.includes(dayOfWeek)) {
            flag = false;
          }
          current = current.add(1, 'day')
        }

        if (flag) { errorMessage = t('general.validations.daysArentValid') }

        const startToValidate = dayjs(fromDateCycli).toDate();
        const endToValidate = dayjs(toDateCycli).toDate();

        const arrayDays = eachDayOfInterval({
          start: startToValidate,
          end: endToValidate,
        })
        const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
        if (duration > dates.length) {
          secondErrorMessage = t('general.validations.isUnderTheDatesRange')
        }

        setErrors(prev => ({
          ...prev,
          days: errorMessage,
          duration: secondErrorMessage
        }))
      }
    }

    if (['fromDateWeekly', 'toDateWeekly', 'duration', 'days'].includes(name)) {
      const fromDateCycli = name == 'fromDateWeekly' ? value : data.fromDateWeekly
      const toDateCycli = name == 'toDateWeekly' ? value : data.toDateWeekly
      const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
      const duration = name == 'duration' ? value.replace(/[a-zA-Z]/g, '') : data.duration?.replace(/[a-zA-Z]/g, '');
      let secondErrorMessage = ''
      if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
        const startToValidate = dayjs(fromDateCycli).toDate();
        const endToValidate = dayjs(toDateCycli).toDate();

        const arrayDays = eachDayOfInterval({
          start: startToValidate,
          end: endToValidate,
        })
        const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
        if (duration > dates.length) {
          secondErrorMessage = t('general.validations.isUnderTheDatesRange')
        }

        setErrors(prev => ({
          ...prev,
          duration: secondErrorMessage
        }))
      }


    }

    setData((prev) => ({
      ...prev,
      ...body
    }))
  }

  useEffect(() => {
    const idUser = userSelectes?.id
    setErrors({})
    if (!!idUser) {
      setFlag(true)
      const dataLocal = useScheduled[idUser]
      /* const to = dataLocal?.to ? dayjs(dataLocal?.to) : null
      const from = dayjs(dataLocal?.from)
      const openQuestionnaire = !!dataLocal?.openQuestionnaire
      const displayStores = !!dataLocal?.displayStores
      const store = dataLocal?.store */
      if (!!dataLocal) {
        if (idUser == 'all') {
          setSelectedDays([DaysWeek.MONDAY, DaysWeek.TUESDAY, DaysWeek.WEDNESDAY, DaysWeek.THURSDAY, DaysWeek.FRIDAY, DaysWeek.SATURDAY, DaysWeek.SUNDAY])
        } else {
          setSelectedDays(dataLocal.selectedDays)
        }
        if (refRange.current?.updateRange) {
          refRange.current.updateRange({
            from: dayjs(dataLocal?.from),
            to: dataLocal?.to ? dayjs(dataLocal?.to) : null,
          })
        }

        setData((prev) => ({
          ...prev,
          ...dataLocal,
          /* displayStores,
          store,
          openQuestionnaire, */
        }))
      } else {
        setSelectedDays([DaysWeek.MONDAY, DaysWeek.TUESDAY, DaysWeek.WEDNESDAY, DaysWeek.THURSDAY, DaysWeek.FRIDAY, DaysWeek.SATURDAY, DaysWeek.SUNDAY])
        setData((prev) => ({
          ...prev,
          notified: false,
          notifiedAdmin: false,
          frequency: FrequencyEnum.UNIQUE,
          from: dayjs(toUnitTimeZone(new Date(), data?.store?.storeTimeZone?.value ?? Constants.defaultTimeZoneObject.value).getTime()),
          to: null,
          openQuestionnaire: false,
          startDateDaily: null,
          endDateDaily: null,
          fromDateDaily: null,
          toDateDaily: null,
          fromDateCycli: null,
          toDateCycli: null,
          startDate: null,
          duration: null,
          endDate: null,
          dayOfWeek: null,
          fromDateWeekly: null,
          toDateWeekly: null,
          durationCycli: null,
          store: null
        }))
      }
      const isBefore = dayjs(dataLocal?.to ? dayjs(dataLocal?.to) : null).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).add(5, 'minute'))
      if (isBefore) {
        setErrors((prev) => ({
          ...prev,
          to: isBefore ? t('useScheduled.detail.errors.currentDateIsNotValidate') : t('useScheduled.detail.errors.minimus5minute'),
        }))
      }
    }
  }, [userSelectes.id])
  const keepSaveSchedule = () => {

    let errorMessage = ''

    const dataCopy = { ...data }
    dataCopy.children = childrenRef.current;
    dataCopy.selectedDays = selectedDays;

    //const from = dayjs(data?.from)
    //const code = data?.store ? ( data?.store.storeTimeZone.value > localOffset ? data?.store.storeTimeZone.code : Intl.DateTimeFormat().resolvedOptions().timeZone ) : "America/Mexico_City"
    //const from = data.from ? dayjs(data.from).tz(code) : dayjs().tz(code)
    //const fromWith5Minutes = from.add(4, 'minute')
    //const to = dayjs(data?.to)

    /* if (to.isBefore(fromWith5Minutes)) {
      setErrors((prev) => ({
        ...prev,
        to: t('useScheduled.detail.errors.minimus5minute'),
      }))
    } */

    if (/* to.isAfter(fromWith5Minutes) */!errorMessage || !!data?.openQuestionnaire) {
      setFlag(true)
      let disabledRemovedList: (string | number)[] = []
      let allUserSchedule = {}
      if (userSelectes.id == 'all') {
        for (const item of row as { id: string }[]) {
          disabledRemovedList.push(item?.id)
          const scheduleData = useScheduled?.[item.id]
          allUserSchedule = {
            ...allUserSchedule,
            [item.id]: {
              ...dataCopy/* data */,
              ...scheduleData && ({
                store: scheduleData?.store ?? null,
                displayStores: scheduleData?.displayStores ?? null,
              })
            }
          }
        }
      } else {
        disabledRemovedList = [userSelectes.id]
        allUserSchedule = {
          ...useScheduled,
          [userSelectes.id]: dataCopy /* data */
        }
      }
      removeDisabled({ arr: disabledRemovedList })
      refTable?.current && refTable?.current?.removeChecks?.({ value: false })
      setUserScheduled(allUserSchedule)

      handleCloseScheduleUser()
    }
  }

  const backButton = () => {
    const button = (
      <Button onClick={() => handleSteps(-1)}>{t('general.return')}</Button>
    )
    const box = <Box className="back" />

    if (!id && !userCannotSelectcUsers()) {
      return !!steps ? button : box
    }
    return steps > 1 ? button : box
  }

  useEffect(() => {
    const userId = userAndQuestionnaireDetail.user
    const questionnaireId = userAndQuestionnaireDetail.questionnaire
    if (!!id && !!userId && !!questionnaireId) {
      const schedule = JSON.parse(
        (userAndQuestionnaireDetail.userAndQuestionnaire as string) ?? ''
      )
      const from = new Date(schedule?.from).getTime()
      const finishFrom = from < Date.now() + 50000 ? Date.now() + 50000 : from
      const to = new Date(schedule?.to).getTime()
      const finishTo = to < finishFrom + 750000 ? finishFrom + 750000 : to
      const store = schedule?.store
      const displayStores = !!schedule?.displayStores
      setUserScheduled((prev) => ({
        ...prev,
        [`${userId}-${questionnaireId}`]: {
          from: finishFrom,
          to: finishTo,
          notifiedAdmin: schedule?.notifyAdmin,
          notified: schedule?.notified,
          openQuestionnaire: !!schedule?.openQuestionnaire,
          ...!!store && { store },
          displayStores
          //aca es para el de editar 
        },
      }))

      setSelectSchedule((prev) => ({
        ...prev,
        0: [userId],
        1: [questionnaireId],
      }))
    }
  }, [id, userAndQuestionnaireDetail])

  useEffect(() => {
    if (!id && userCannotSelectcUsers() && list?.users?.[0]?.id?.toString()) {
      setSelectSchedule((prev) => ({
        ...prev,
        0: [list?.users?.[0]?.id?.toString() ?? ''],
      }))
    }
  }, [list])

  const disabledUserWithoutPermissions = () => {
    return disabledChecks?.[steps] ?? []
  }

  useEffect(() => {
    if (userSelectes.id /* && Boolean(data.displayStores) */ && !Boolean(items.stores?.length)) {
      getUserUnits({ /* displayStores: data.displayStores, */ id: String(userSelectes.id) })
    }
  }, [userSelectes.id, data.displayStores])
  useEffect(() => {
    const defaultDate = dayjs(toUnitTimeZone(new Date(), data?.store?.storeTimeZone?.value ?? Constants.defaultTimeZoneObject?.value))
    const fromIsLow = defaultDate.isAfter(dayjs(data?.from), 'seconds')
    const toIsLow = defaultDate.isAfter(dayjs(data?.to), 'seconds')
    setData(prev => ({ ...prev, ...!!toIsLow && { to: null }, ...!!fromIsLow && { from: defaultDate } }))
    if (data?.store) {
      setMimTimeZone({ code: data?.store.storeTimeZone.code, value: data?.store.storeTimeZone.value })
    } else {
      setMimTimeZone(Constants.defaultTimeZoneObject)
    }
  }, [data?.store?.storeTimeZone?.code])
  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <Box>
          <Box sx={styles.headerLeft}>
            <IconButton onClick={() => goBack()}>
              {icons('arrow-left-fill')}
            </IconButton>

            <Typography>
              {!id
                ? t('schedule.assigned.backToList')
                : t('schedule.assigned.editPlanification')}
            </Typography>
          </Box>

          <Box>
            <Typography sx={styles.title}>{!id ? t('schedule.assigned.calendarCreate') : t('schedule.assigned.calendarEdit')}</Typography>
          </Box>
        </Box>

        <Box sx={styles.stepper}>
          <StepperCreate
            color={colors}
            steps={
              stepsList
                ?.filter((item) => !!item)
                .map((item) => ({
                  label: item.label,
                  step: `Paso ${item.step}`,
                })) as {
                  label: string
                  step: string
                }[]
            }
            activeStep={!!id || userCannotSelectcUsers() ? steps - 1 : steps}
          />
        </Box>
      </Box>

      <Box sx={styles.buttonsContainer}>
        {backButton()}

        {(steps ?? 0) < 2 && !id && (
          <Typography className="message">
            {steps === 0 && !id
              ? t('schedule.assigned.doYouNeedSelectedAlLeastOneU')
              : t('schedule.assigned.doYouNeedSelectedAlLeastOneQ')}
          </Typography>
        )}

        <Box sx={styles.flex}>
          <Button
            disabled={handleDisabled()}
            className="next"
            variant="contained"
            onClick={() => {
              if (!id || (!!id && !isLoadingEndpoints?.questionnaires)) {
                handleSteps(1)
              }
            }}
          >
            {[2, 3].includes(steps ?? 0)
              ? t(`schedule.buttons.${id ? 'updateScheduled' : 'addScheduled'}`)
              : t('general.continue')}
          </Button>
        </Box>
      </Box>

      <Box sx={styles.body}>
        <Box sx={styles.headerTitle}>
          <Typography>{titles[steps + 1]}</Typography>

          <Box sx={styles.containerFilter}>
            <IconButton
              sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
              onClick={() => {
                handleCheanFilter()
              }}
            >
              {icons('clean')}
            </IconButton>

            <Box sx={styles.drawerfilter}>
              <FiltersDrawer
                cleanFilter={handleCheanFilter}
                count={counter}
              /* right={0}
              top={50} */
              >
                <Box sx={styles.section}>
                  <DinamicForm
                    errors={errors}
                    input={Object.values(input[steps] ?? {})}
                    values={filterData[steps] ?? {}}
                    onChange={(e) => {
                      handleFilter({ e })
                    }}
                    filter={true}
                  />
                </Box>
              </FiltersDrawer>
            </Box>
          </Box>
        </Box>

        <CurrentStep
          id={id}
          mimTimeZone={mimTimeZone}
          ref={refTable}
          setErrors={setErrors}
          flag={flag}
          setFlag={setFlag}
          setStartDate={setStartDate}
          startDate={startDate}
          selectedDays={selectedDays}
          setSelectedDays={setSelectedDays}
          children={children}
          childrenRef={childrenRef}
          setChildren={setChildren}
          setData={setData}
          items={items}
          loadings={loadings}
          disabledChecks={disabledUserWithoutPermissions()}
          isLoadingEndpoints={isLoadingEndpoints}
          columns={columns}
          rows={row}
          data={data}
          currentUser={currentUser}
          diabledSaveSchedule={disableAssginedSchedule}
          errors={errors}
          handleCloseScheduleUser={() => {
            handleCloseScheduleUser()
            setData({})
          }}
          keepSaveSchedule={keepSaveSchedule}
          handleSelect={handleSelect}
          onChange={onChange}
          selectSchedule={selectSchedule[steps]}
          steps={steps}
          userSelectes={userSelectes}
          refRange={refRange}
        />
      </Box>

      <Box sx={styles.buttonsContainer}>
        {backButton()}

        {/* {(steps ?? 0) < 2 && !!footers?.[steps] && (
          <Typography className="message">{footers?.[steps] ?? ''}</Typography>
        )} */}

        <Button
          disabled={handleDisabled()}
          className="next"
          variant="contained"
          onClick={() => handleSteps(1)}
        >
          {[2, 3].includes(steps ?? 0)
            ? t(`schedule.buttons.${id ? 'updateScheduled' : 'addScheduled'}`)
            : t('general.continue')}
        </Button>
      </Box>

      <SimpleModal
        open={openModal.open}
        close={handleCloseModal}
        children={openModal.children}
        title={openModal.title}
        description={openModal.description}
        buttonText={t('general.confirm')}
        cancelText={!!openModal?.removeCancel ? undefined : t('general.cancel')}
        color={colors}
        back={!!openModal?.removeCancel ? undefined : handleCloseModal}
        loadingButton
        disableButton={isLoadingConfirm}
        isLoading={isLoadingConfirm}
        next={() => {
          openModal?.method?.()
        }}
      />
    </Box>
  )
}

export { UserScheduleDetail }
